export default{
    autManagement:{
        titleBox:{
            title1:'Authentication Type',
            title2:'Identity Verification',
            title3:'(Free)',
            title4:'Verification Content',
            title5:'Verification Status',
        },
        showList:{
            show1:'Under Review',
            show2:'Verification Failed',
            show3:'Verified',
            show4:'Not Verified',
            show5:'Action',
            show6:'Verify Now',
            show7:'View Details',
            show8:'Individual',
            show9:'Individual verification confirms your identity through ID authentication. Verified users gain credibility for long-term transactions and priority dispute resolution.',
            show10:'Enterprise',
            show11:'Enterprise verification provides multiple privileges, building trust between buyers and sellers for easier business transactions.'
        },

        autManageDetail:{
            anage1:'Your submission is under review. Processing time: 1-2 business days.',
            anage2:'Individual verification failed. Please modify and resubmit.',
            anage3:'Application Date:',
            anage4:'Verification Status:',
            anage5:'Under Review',
            anage6:'Verification Failed',
            anage7:'Verified',
            anage8:'Review Notes:',
            anage9:'Full Name:',
            anage10:'Gender:',
            anage11:'ID Number:',
            anage12:'ID Expiry Date:',
            anage13:'Mobile:',
            anage14:'Document Images:',
            anage15:'ID Front',
            anage16:'ID Back',
            anage17:'ID Holding Photo',
            anage18:'Edit',
            anage19:'Back to My Verification',
        },
        entpAuth:{
            entpAuth1:'After successful enterprise verification, this account will become an enterprise account.',
            entpAuth2:'Company',
            entpAuth3:'Company Name:',
            entpAuth4:'Registered Region:',
            entpAuth5:'Detailed Address:',
            entpAuth6:'Contact Person:',
            entpAuth7:'Contact Number:',
            entpAuth8:'Business License:',
            entpAuth9:'Cancel',
            entpAuth10:'Submit for Review',
            entpAuth11:'Saved Successfully',
        },
        entpAuthFrom:{
            rule1:'Enter company name',
            rule2:'Enter 4-50 character company name',
            rule3:'Select registered address',
            rule4:'Enter detailed address',
            rule5:'Enter 2-50 character detailed address',
            rule6:'Enter contact name',
            rule7:'Enter 2-20 character contact name',
            rule8:'Enter contact number',
            rule9:'Enter valid phone number',
            rule10:'Upload business license',
            rule11:'Business license must be JPG/JPEG/PNG under 10MB',
            rule12:'Enter full address including street, building, unit number etc.'
        },
        entpAuthDetail:{
            entp1:'Your submission is under review. Processing time: 1-2 business days.',
            entp2:'Enterprise verification not approved',
            entp3:'Application Date:',
            entp4:'Review Status:',
            entp5:'Under Review',
            entp6:'Approved',
            entp7:'Rejected',
            entp8:'Review Notes:',
            entp9:'Company Name:',
            entp10:'Contact Person:',
            entp11:'Contact Number:',
            entp12:'Registered Address:',
            entp13:'Business License:',
            entp14:'Edit',
            entp15:'Back to My Verification',
        }
    }
}